import { defaultBillingAccountId } from "@/mock-api/data/billingAccountIds.ts";
import { ubuntuId, windowsId } from "@/mock-api/data/vmIds.ts";
import { randomUuid } from "@/mock-api/randomTypes.ts";
import type { Firewall } from "@warrenio/api-spec/spec.oats.gen";

const user_id = 328;

export const firewallList1: Firewall[] = [
    {
        display_name: "Firewall 1",
        uuid: "a1b2c3d4-e5f6-7890-1234-567890abcdef",
        created_at: "2022-11-07 07:38:41",
        user_id: user_id,
        billing_account_id: defaultBillingAccountId,
        rules: [
            {
                uuid: randomUuid(),
                policy_action: "pass",
                direction: "inbound",
                protocol: "tcp",
                port_start: 5432,
                endpoint_spec_type: "ip_prefixes",
                endpoint_spec: ["10.0.1.0/24"],
            },
            {
                uuid: randomUuid(),
                policy_action: "pass",
                direction: "inbound",
                protocol: "icmp",
                port_start: 0,
                endpoint_spec_type: "any",
                endpoint_spec: ["10.0.1.0/24"],
            },
            {
                uuid: randomUuid(),
                policy_action: "pass",
                direction: "outbound",
                protocol: "tcp",
                port_start: 443,
                endpoint_spec_type: "ip_prefixes",
                endpoint_spec: ["10.0.1.0/24"],
            },
        ],
        resources_assigned: [
            {
                resource_uuid: ubuntuId,
                resource_type: "vm",
            },
            {
                resource_uuid: windowsId,
                resource_type: "vm",
            },
        ],
    },
    {
        display_name: "Firewall 2",
        uuid: "a1b2c3d4-e5f6-1234-1234-561895abcdef",
        created_at: "2022-11-07 07:38:41",
        user_id: user_id,
        billing_account_id: defaultBillingAccountId,
        rules: [],
        resources_assigned: [],
    },
];

export const firewallList2: Firewall[] = [];
